import React from "react";
import Accordion from "@components/common/accordion";
import { useFaqsQuery } from "@framework/content/get-faq";
import Container from "@components/ui-old/container";
import FAQLoader from "@components/ui-old/loaders/faq-loader";
import Divider from "@components/other/divider";
import GoldIcon from "@components/Svg/gold-icon";
const FaqSection: React.FC = () => {
  const {
    data,
    isLoading,
    error
  } = useFaqsQuery("non_fbo");
  if (isLoading) {
    return <FAQLoader />;
  }
  if (error || !data || data.length === 0) {
    return null;
  }
  const faqItems = data.map(faq => ({
    id: faq.id,
    title: faq.question,
    content: faq.answer
  }));
  return <>
      <Divider icon={GoldIcon} data-sentry-element="Divider" data-sentry-source-file="faq-section.tsx" />
      <Container data-sentry-element="Container" data-sentry-source-file="faq-section.tsx">
        <div className="py-16 lg:py-20 px-0 max-w-5xl mx-auto space-y-4">
          <Accordion items={faqItems} translatorNS="faq" data-sentry-element="Accordion" data-sentry-source-file="faq-section.tsx" />
        </div>
      </Container>
    </>;
};
export default FaqSection;